import { Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import AnimationClip from '../AnimationClip';

export class FoxShadowIdle extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        const sy: number = transform.scale.y;
        const pulseTween = this.getTween(transform.scale);

        pulseTween
            .to({ y: sy + 0.03 }, 600)
            .easing(Easing.Quadratic.Out)
            .yoyo(true)
            .repeat(Infinity);

        yield* this.startTween(pulseTween);
    }
}
